<template>
  <b-form-group
    label="Sıra No"
    label-for="ordering"
  >
    <validation-provider
      #default="{ errors }"
      name="Sıra No"
      rules="required"
    >
      <b-form-input
        id="ordering"
        v-model="dataItem.ordering"
        placeholder="Sıra No"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'CorporatePoliciesOrderingCard',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['corporatePolicies/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
